var exports = {
  "K": "SavedMessagesPage.module__icon___eU9XS1",
  "r": "SavedMessagesPage.module__missingList___eU9XS1",
};

module.exports = exports;
